export default [
  '#ffb142',
  '#1f8369',
  '#2d69eb',
  '#c582ff',
  '#c93c2d',
  '#07a95c',
  '#17a2b8',
];
